import { render, staticRenderFns } from "./SampleHome.vue?vue&type=template&id=0dec3a91&scoped=true&"
import script from "./SampleHome.vue?vue&type=script&lang=js&"
export * from "./SampleHome.vue?vue&type=script&lang=js&"
import style0 from "./SampleHome.vue?vue&type=style&index=0&id=0dec3a91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec3a91",
  null
  
)

export default component.exports